// extracted by mini-css-extract-plugin
module.exports = {"shared":"\"../../../shared.module.css\"","lg":"992px","emptyFavoritesContainer":"EmptyFavorites_emptyFavoritesContainer__3sf2F"};